import {
  Divider,
  NewTitleButton,
  RightBoxContainer,
  TitleContainer,
} from './DraftReportTabs.styles';
import React, { FC, Fragment } from 'react';

interface Props {
  headers: string[];
  headerComponent: React.JSX.Element;
  headerIndex: number;
  setHeaderIndex: React.Dispatch<React.SetStateAction<number>>;
}

export const DraftReportTabs: FC<Props> = (props) => (
  <RightBoxContainer>
    <TitleContainer>
      {props.headers.map((header, index) => (
        <Fragment key={header}>
          <NewTitleButton
            title={header}
            onClick={() => props.setHeaderIndex(index)}
            selected={index === props.headerIndex}
            data-testid={header}
            weight={'regular'}
            noMargin={true}
          />
          {index !== props.headers.length - 1 && <Divider />}
        </Fragment>
      ))}
    </TitleContainer>
    {props.headerComponent}
  </RightBoxContainer>
);
